import { plural, t } from "@helpers/translate";
import { DateTime } from "luxon";

export const getDateDiff = (ISODate: string) => {
  if (!ISODate) {
    return "--";
  }

  const date = DateTime.fromISO(ISODate);
  const duration = DateTime.now().diff(date, ["hours", "days"]).toObject();

  if (!duration.hours || !duration.days) {
    return t({
      id: "date.diff.today",
      message: "Today",
    });
  }

  const days = Number(duration.days.toFixed());

  if (days > 5) {
    return "--";
  }

  if (days > 0) {
    return t({
      id: "date.diff.days",
      message: plural(days, {
        one: `${days} day ago`,
        other: `${days} days ago`,
      }),
      values: {
        days: `${days}`,
      },
    });
  }

  const hours = Number(duration.hours.toFixed());

  if (hours > 0) {
    return t({
      id: "date.diff.hours",
      message: plural(hours, {
        one: `${hours} hour ago`,
        other: `${hours} hours ago`,
      }),
      values: {
        hours: `${hours}`,
      },
    });
  }

  return "--";
};
